// src/Dashboard/pages/user/Absences/components/InfoBanner.jsx

import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { INFO_TXT } from "../constants/absenceConstants";

export default function InfoBanner() {
  return (
    <div className="rounded-[1.5rem] border border-sky-200 bg-sky-50/90 p-4 text-sm leading-6 text-slate-700 shadow-sm dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-slate-200">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-white text-sky-600 shadow-sm dark:bg-slate-900">
          <FaInfoCircle />
        </span>

        <p>{INFO_TXT}</p>
      </div>
    </div>
  );
}